export const FETCH_BANKS_REQUEST = 'FETCH_BANKS_REQUEST';
export const FETCH_BANKS_SUCCESS = 'FETCH_BANKS_SUCCESS';
export const FETCH_BANKS_FAILURE = 'FETCH_BANKS_FAILURE';
export const FETCH_MONTHLY_EXCHANGE_RATE_REQUEST =
  'FETCH_MONTHLY_EXCHANGE_RATE_REQUEST';
export const FETCH_MONTHLY_EXCHANGE_RATE_SUCCESS =
  'FETCH_MONTHLY_EXCHANGE_RATE_SUCCESS';
export const FETCH_MONTHLY_EXCHANGE_RATE_FAILURE =
  'FETCH_MONTHLY_EXCHANGE_RATE_FAILURE';
export const FETCH_YEARLY_EXCHANGE_RATE_REQUEST =
  'FETCH_YEARLY_EXCHANGE_RATE_REQUEST';
export const FETCH_YEARLY_EXCHANGE_RATE_SUCCESS =
  'FETCH_YEARLY_EXCHANGE_RATE_SUCCESS';
export const FETCH_YEARLY_EXCHANGE_RATE_FAILURE =
  'FETCH_YEARLY_EXCHANGE_RATE_FAILURE';
export const FETCH_CURRENCIES_INFO_REQUEST = 'FETCH_CURRENCIES_INFO_REQUEST';
export const FETCH_CURRENCIES_INFO_SUCCESS = 'FETCH_CURRENCIES_INFO_SUCCESS';
export const FETCH_CURRENCIES_INFO_FAILURE = 'FETCH_CURRENCIES_INFO_FAILURE';
export const FETCH_CURRENCIES_CROSS_RATES_REQUEST =
  'FETCH_CURRENCIES_CROSS_RATES_REQUEST';
export const FETCH_CURRENCIES_CROSS_RATES_SUCCESS =
  'FETCH_CURRENCIES_CROSS_RATES_SUCCESS';
export const FETCH_CURRENCIES_CROSS_RATES_FAILURE =
  'FETCH_CURRENCIES_CROSS_RATES_FAILURE';
export const FETCH_CURRENCY_RATES_FROM_URL_REQUEST =
  'FETCH_CURRENCY_RATES_FROM_URL_REQUEST';
export const FETCH_CURRENCY_RATES_FROM_URL_SUCCESS =
  'FETCH_CURRENCY_RATES_FROM_URL_SUCCESS';
export const FETCH_CURRENCY_RATES_FROM_URL_FAILURE =
  'FETCH_CURRENCY_RATES_FROM_URL_FAILURE';

export const FETCH_CONVERTOR_RATES_GRAPH_REQUEST =
  'FETCH_CONVERTOR_RATES_GRAPH_REQUEST';
export const FETCH_CONVERTOR_RATES_GRAPH_SUCCESS =
  'FETCH_CONVERTOR_RATES_GRAPH_SUCCESS';
export const FETCH_CONVERTOR_RATES_GRAPH_FAILURE =
  'FETCH_CONVERTOR_RATES_GRAPH_FAILURE';

export const FETCH_CURRENCIES_REQUEST = 'FETCH_CURRENCIES_REQUEST';
export const FETCH_CURRENCIES_SUCCESS = 'FETCH_CURRENCIES_SUCCESS';
export const FETCH_CURRENCIES_FAILURE = 'FETCH_CURRENCIES_FAILURE';

export const FETCH_LINKS_DATA_REQUEST = 'FETCH_LINKS_DATA_REQUEST';
export const FETCH_LINKS_DATA_SUCCESS = 'FETCH_LINKS_DATA_SUCCESS';
export const FETCH_LINKS_DATA_FAILURE = 'FETCH_LINKS_DATA_FAILURE';
